import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceStandardsPage } from "@/components/workspace-standards/WorkspaceStandardsPage";

export const Route = createFileRoute("/$workspaceSlug/standards/")({
  component: WorkspaceStandardsPage,
});
